import { render, staticRenderFns } from "./EditIdTag.vue?vue&type=template&id=08cbd93c&scoped=true&"
import script from "./EditIdTag.vue?vue&type=script&lang=ts&"
export * from "./EditIdTag.vue?vue&type=script&lang=ts&"
import style0 from "./EditIdTag.vue?vue&type=style&index=0&id=08cbd93c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cbd93c",
  null
  
)

export default component.exports